
interface AppPage {
    url: string;
    title: string;
    title_en: string;
    indexTitle: string;
    indexTitle_en: string;
    indexSubTitle: string;
    indexSubTitle_en: string;
    icon: string;
  }
  
export const appPages: AppPage[] = [
    {
      title: 'Benvenuti',
      title_en: 'Welcome',
      url: '/home',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-1.svg`,
      indexTitle: '',
      indexTitle_en: '',
      indexSubTitle: '',
      indexSubTitle_en: ''
    },
    {
      title: 'Bollettini e Avvisi (NtS)',
      title_en: 'Bulletins and Notices (NtS)',
      indexTitle: 'Bollettini',
      indexTitle_en: 'Bulletins',
      indexSubTitle: 'e Avvisi',
      indexSubTitle_en: 'and Notices (NtS)',
      url: '/batimetric',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-11b.svg`
    },
    {
      title: 'Carta nautica digitale',
      title_en: 'Digital Nautical Chart',
      indexTitle: 'Carta nautica',
      indexTitle_en: 'Digital',
      indexSubTitle: 'digitale',
      indexSubTitle_en: 'Nautical Chart',
      url: '/docksMap',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-5.svg`
    },
    {
      title: 'Ponti e Conche',
      title_en: 'Bridges & Locks',
      indexTitle: 'Ponti',
      indexTitle_en: 'Bridges',
      indexSubTitle: 'e Conche',
      indexSubTitle_en: 'Locks',
      url: '/bridges',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-12.svg`
    },
    {
      title: 'Carte del fiume Po',
      title_en: 'Po River Maps',
      indexTitle: 'Carte del',
      indexTitle_en: 'Po River',
      indexSubTitle: 'Fiume Po',
      indexSubTitle_en: 'Maps',
      url: '/maps',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-3.svg`
    },
    {
      title: 'Riserve della Biosfera',
      title_en: 'Biosphere Reserves',
      indexTitle: 'Riserve della',
      indexTitle_en: 'Biosphere',
      indexSubTitle: 'Biosfera',
      indexSubTitle_en: 'Reserves',
      url: '/islands',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-4b.svg`
    },
    {
      title: 'Lista attracchi',
      title_en: 'Docks List',
      indexTitle: 'Lista Attracchi',
      indexTitle_en: 'Docks List',
      indexSubTitle: 'sul Po',
      indexSubTitle_en: 'on the Po',
      url: '/docks',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-2.svg`
    },
    {
      title: 'Segnaletica e Regolamento',
      title_en: 'Signals and Regulations',
      indexTitle: 'Segnaletica',
      indexTitle_en: 'Signals',
      indexSubTitle: 'e Regolamento',
      indexSubTitle_en: 'and Regulations',
      url: '/signs',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-6.svg`
    },
    {
      title: 'Norme sulla Navigazione',
      title_en: 'Navigation Rules',
      indexTitle: 'Normative di',
      indexTitle_en: 'Navigation',
      indexSubTitle: 'Navigazione',
      indexSubTitle_en: 'Rules',
      url: '/rulebook',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-10.svg`
    },
    {
      title: 'Invio segnalazioni',
      title_en: 'Send Reports',
      indexTitle: 'Invio',
      indexTitle_en: 'Send',
      indexSubTitle: 'Segnalazioni',
      indexSubTitle_en: 'Reports',
      url: '/feedback',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-7.svg`
    },
    {
      title: 'Promotori',
      title_en: 'Promoters',
      indexTitle: 'Enti',
      indexTitle_en: 'Promoters',
      indexSubTitle: 'Promotori',
      indexSubTitle_en: '',
      url: '/credits',
      icon: `${process.env.PUBLIC_URL}/assets/images/portolanoPo-icon-8.svg`
    },
    {
      title: 'Operatori del Fiume Po',
      title_en: 'Po River Operators',
      indexTitle: 'Operatori del',
      indexTitle_en: 'Po River',
      indexSubTitle: 'Fiume Po',
      indexSubTitle_en: 'Operators',
      url: '/meatori',
      icon: `${process.env.PUBLIC_URL}/assets/images/user.svg`
    }
  ];